import React, { useEffect, useState } from "react";
import 'rodal/lib/rodal.css';
import 'index.scss';
import PropTypes from "prop-types";
import './ModalWinPrize.scss'
import { schoolPride, stopConfetti } from 'helpers/animation';
import icClose from 'static/ic-close.png';
import icLosing from 'static/ic-losing.png';
import btnContinue from 'static/btn-continue.png';
import bgRodal from 'static/bg-rodal.png';
import Rodal from 'rodal';
import styled from "styled-components";
import { PRIZE_THUMB, PRIZE_TYPE } from "helpers/constants";
import { renderRandMessage } from "helpers/helpers";
import winGame from 'static/music/win_game.mp3';
import * as selectors from "store/selectors";
import { connect } from "react-redux";
import useSound from 'use-sound';
import { getGameAsset } from 'helpers/gameAssets';

const Image = styled.img`
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
`
const Background = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
`

const ModalWinPrize = ({ isOpen, message, isSound, prizeType, title, isAuto, onCloseModal, gameCode }) => {

    const [play, { stop }] = useSound(winGame);
    // const thumb = prizeType ? PRIZE_THUMB[prizeType] : icLosing;
    // const content = prizeType ? message : renderRandMessage();
    const [thumb, setThumb] = useState(null)
    const [content, setContent] = useState(null);

    console.log("Win prize render....");
    useEffect(() => {
        if (isOpen) {
            console.log("Win prize render set content....");
            setThumb(prizeType === PRIZE_TYPE.MONEY
                ? getGameAsset(gameCode, 'prize-money', PRIZE_THUMB[prizeType])
                : prizeType ? PRIZE_THUMB[prizeType] : getGameAsset(gameCode, 'ic-losing', icLosing));
            setContent(prizeType ? message : renderRandMessage());
        }

    }, []);
    useEffect(() => {
        if (isOpen) {
            if (prizeType) {
                schoolPride();
            }
            if (isAuto) setTimeout(() => handleCloseModal(), 2000);
        }
    }, [isOpen]);

    useEffect(() => {
        if (isOpen && prizeType && isSound) {
            play();
        }
    });

    const handleCloseModal = () => {
        stopConfetti();
        onCloseModal();
    }

    return (
        <div>
            <Rodal className="rodal" visible={isOpen} onClose={() => handleCloseModal()} showCloseButton={false} closeMaskOnClick={false}>
                <Image className="icon-header" src={icClose} onClick={() => handleCloseModal()} style={{ visibility: `${isAuto ? "hidden" : "unset"}` }} />
                <Background src={getGameAsset(gameCode, 'bg-rodal', bgRodal)} />
                <div className={`rodal-content  ${!prizeType && "mt-[3rem]"}`}>
                    <img className="align-center" src={thumb} alt="prize-thumb" style={{ height: "10.25rem" }} />
                    {prizeType && <p className="uppercase title">{title}</p>}
                    <p className="message">{content}</p>
                    <img className="align-center" src={btnContinue} onClick={() => { stop(); handleCloseModal() }} style={{ visibility: `${isAuto ? "hidden" : "unset"}`, width: "7rem" }} />
                </div>
            </Rodal>
        </div>
    );
}

ModalWinPrize.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    prizeType: PropTypes.string
};

const mapStateToProps = (state) => ({
    isSound: selectors.getSound(state),
})

export default connect(mapStateToProps, null)(ModalWinPrize);